import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { ContactsRedux } from '../Redux/ContactsRedux'
import { CompaniesRedux } from '../Redux/CompaniesRedux'

const contactsCrudObservable = createCRUDObservable({
  mainRedux: ContactsRedux,
  reduxPath: 'contacts',
  create: {
    onSuccessActions: [
      {
        redux: CompaniesRedux,
        pathToUpdate: 'contacts',
      },
    ],
  },
  remove: {
    onSuccessActions: [
      {
        redux: CompaniesRedux,
        pathToUpdate: 'contacts',
      },
    ],
  },
})

export const contactsObservers = Object.assign({}, contactsCrudObservable.observers, {})

export const contactsEpic = combineEpics(
  contactsCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ContactsObservable.js